<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{title}}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <div class="cheader">
          <h1 id="cname">&nbsp;</h1>
          <p id="csub">{{message}}</p>
          <div class="caction">
                <div v-if="result==='success'" class="cphone">
                    <img src="../assets/success.png"/>
                    <p>&nbsp;</p>
                </div>
                <div v-if="result==='error'"  class="cphone">
                    <img src="../assets/error.png"/>
                    <p>&nbsp;</p>
                </div>
            </div>
      </div>
      <ion-button @click="closeMe" expand="full">Close</ion-button>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'results-modal',
    props:{
        title:{
            type:String,
            default:'Modal'
        },
        message:{
            type:String,
            default:'Message'
        },
        result:{
            type:String,
            default:'success'
        },
        closeMe: { type: Function, default: () => {} }
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
.cheader{
    border-bottom:1px solid #f3f3f5;
    background-color:#fbfaff;
    padding-bottom:66px;
    padding-right:11px;
    padding-left:11px;
    position:relative;
    padding-top:33px;
    cursor:default;
    width:100%;
}
#cname {
    vertical-align:middle;
    margin-bottom:10px;
    margin-top:44px;
    text-align:center;
    line-height:1em;
    font-size:2.2em;
    width:100%;
}
#csub{
    text-align:center;
    font-weight:300;
    font-size:1.1em;
    color:#808080;
}
.caction {
    justify-content: center;
    display: flex;
}
.cphone {
    border-radius:30px;
    margin-bottom:11px;
    margin-right:20px;
    margin-left:20px;
    margin-top:22px;
    cursor:pointer;
    height:40px;
    width:40px;
}
.cphone img{
    vertical-align:middle;
    text-align:center;
    line-height:60px;;
    font-size:30px;
    color:white;
    height:40px;
    width:40px;
}
.cphone p{
    text-align:center;
    font-size:0.8em;
    margin-top:10px;
    cursor:default;
    color:#1b9346;
}
.cinfo {
    background-color:white;
    cursor:default;
    padding:40px;
    width:100%;
}
.cinfo-label {
    display:inline;
    font-size:1em;
}
.cinfo-value {
    padding-bottom:22px;
    margin-bottom:11px;
    padding-top:11px;
    font-size:1.3em;
    cursor:pointer;
    color:#1c7ef8;
}
.divider {
    border: 1px solid #f3f3f5;
    margin-bottom:44px;
}
</style>